// extracted by mini-css-extract-plugin
export var fadeIn = "_8m-0";